import { Stack, Box } from '@mui/material';
import { FC, useMemo } from 'react';
import { useFormContext } from 'react-hook-form';
import Input from '~/ui/components/inputs/Input';

import styles from './SourceManagerColumn.module.scss';
import PatientList from '../PatientList';
import { IFormValues } from '../../types';
import { IUserPatientDto, IUserList } from '~/services/api/users/types';

interface IProps {
  sourceUser: IUserList;
  selectedIds: number[];
  disabledIds: number[];
  patients: IUserPatientDto[];
  onSelect: (ids: number[]) => void;
}
const SourceManagerColumn: FC<IProps> = ({
  sourceUser,
  selectedIds,
  disabledIds,
  patients,
  onSelect,
}) => {
  const {
    register,
    watch,
    formState: { errors },
  } = useFormContext<IFormValues>();

  const search = watch('sourceSearch') || '';

  const filtered = useMemo(
    () => patients.filter(x => x.fullName.toLowerCase().includes(search.toLowerCase())),
    [patients, search],
  );

  return (
    <Stack spacing={2}>
      <Box className={styles.managerHeader}>{sourceUser.fullName}</Box>
      <Input register={register} name="sourceSearch" label="Search Patients" errors={errors} />
      <PatientList
        patients={filtered}
        selectedIds={selectedIds}
        disabledIds={disabledIds}
        onToggle={id =>
          onSelect(
            selectedIds.includes(id) ? selectedIds.filter(x => x !== id) : [...selectedIds, id],
          )
        }
      />
    </Stack>
  );
};

export default SourceManagerColumn;
